export default "__VITE_ASSET__kNByW3XL__"